export default [
    {
        path: '/auth/signin',
        name: 'signin',
        meta: {
            title: "Sign In", authRequired: false,
        },
        component: () => import('../views/auth/signin')
    },
    {
        path: '/auth/signup',
        name: 'register',
        meta: {
            title: "Register", authRequired: false,
        },
        component: () => import('../views/auth/signup')
    },{
        path: '/auth/register',
        name: 'register',
        meta: {
            title: "Register", authRequired: false,
        },
        component: () => import('../views/auth/signup.vue')
    },
    {
        path: "/account/complete-registration",
        name: "complete-registration",
        meta: {title: "complete-registration", authRequired: true},
        component: () => import("../views/account/complete-registration.vue"),
    },  {
        path: "/account/register-pe",
        name: "register-pe",
        meta: {title: "Register Procuring Entity", authRequired: true},
        component: () => import("../views/account/register-pe.vue"),
    },
    {
        path: '/auth/reset-pwd',
        name: 'reset-pwd',
        meta: {
            title: "Reset Password", authRequired: false,
        },
        component: () => import('../views/auth/reset.vue')
    },
    {
        path: '/auth/verification',
        name: 'verification',
        meta: {
            title: "Email Verification", authRequired: false,
        },
        component: () => import('../views/auth/verification.vue')
    },
    {
        path: '/auth/404',
        name: '404',
        meta: {
            title: "Error 404", authRequired: false,
        },
        component: () => import('../views/auth/errors/404')
    },
    {
        path: '/auth/500',
        name: '500',
        meta: {
            title: "Error 500", authRequired: true,
        },
        component: () => import('../views/auth/errors/500')
    },
    {
        path: '/auth/404-cover',
        name: '404-cover',
        meta: {
            title: "Error 404", authRequired: true,
        },
        component: () => import('../views/auth/errors/404.vue')
    },
    {
        path: '/auth/logout',
        name: 'logout',
        meta: {
            title: "Logout", authRequired: true,
        },
        component: () => import('../views/auth/logout.vue')
    },
    {
        path: '/auth/success-msg-cover',
        name: 'success-msg-cover',
        meta: {
            title: "Success Message", authRequired: true,
        },
        component: () => import('../views/auth/success.vue')
    },

    {
        path: "/account/my-account",
        name: "my-account",
        meta: {title: "my-account", authRequired: true},
        component: () => import("../views/account/my-account"),
    },
    {
        path: "/account/manage-accounts",
        name: "manage-accounts",
        meta: {title: "manage-accounts", authRequired: true},
        component: () => import("../views/account/manage-accounts"),
    },
    {
        path: "/account/manage-pe-account",
        name: "manage-pe-account",
        meta: {title: "manage-pe-account", authRequired: true},
        component: () => import("../views/account/manage-pe-account"),
    },
    {
        path: "/profiles/supplier-account",
        name: "supplier",
        meta: {title: "Supplier Account", authRequired: false},
        component: () => import("../views/account/my-account"),
    },
    {
        path: "/profiles/suppliers",
        name: "suppliers",
        meta: {title: "Supplier Account", authRequired: false},
        component: () => import("../views/manage-profile/manage-suppliers"),
    },
    {
        path: "/profiles/register-supplier",
        name: "register-supplier",
        meta: {title: "Register Supplier", authRequired: false},
        component: () => import("../views/manage-profile/register-supplier"),
    }
]